module.exports = __webpack_public_path__ + "static/img/push.7297b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/push.png
// module id = cZc/
// module chunks = 2